import React from 'react';
import image from '../../../assets/img/logo-kothe-xs.png';

const App: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <img src={image} alt="logo" style={{ width: '25px' }} />
      <p>Kothe Logística ©{year}</p>
    </div>
  );
};

export default App;
